import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query';

export function useMyQuery<TFn, TData>(
  data: UndefinedInitialDataOptions<TFn, Error, TData, any[]>
) {
  const q = useQuery({
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60, // treat data as fresh for 1 minute
    gcTime: 1000 * 60 * 5, // keep cached for 5 minutes
    ...data,
  });

  return q;
}
